import styled from 'styled-components';

const TopbarWrapper = styled.div`
  .topbar {
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    z-index: 1000;
    padding: 0;

    .boxed {
      margin: 0 auto;
      padding-left: 40px;
      padding-right: 40px;

      @media (min-width: 1200px) {
        width: 1200px;
      }
    }

    img {
      height: 50px;
      margin: 10px 0;
    }
  }
`;

export default TopbarWrapper;



// WEBPACK FOOTER //
// ./src/components/Topbar/topbar.style.js